import { observable, action, runInAction, computed, toJS } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { rightsParameter } from '@services/api'

export class rightsParametersStore extends StoreExt {
    @observable list = []

    @action
    updateRightParameter = async rightParameter => {
        await rightsParameter.updateRightParameter({ ...rightParameter })
    }

    @action
    deleteRightParameters = async params => {
        await rightsParameter.deleteRightParameters({ ...params })
    }
}

export default remotedev(new rightsParametersStore())
